import { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router';
import { StreamrTvViewer } from '../engine/StreamrTvViewer';
import { useSetViewerCountCallback } from '../state/viewerCountState';
export function useStreamrTvViewer({ streamId, canvas, onStarted, onReceivedFrame, }) {
    const [viewer, setViewer] = useState();
    const setViewerCountCallback = useSetViewerCountCallback();
    // Track the last canvas we saw to detect changes
    const lastCanvasRef = useRef(undefined);
    const onStartedRef = useRef(onStarted);
    if (onStartedRef.current !== onStarted) {
        onStartedRef.current = onStarted;
    }
    const aesKey = useSearchParams()[0].get('aesKey');
    if (!aesKey) {
        throw new Error('No key provided in URL');
    }
    const broadcasterPublicKey = useSearchParams()[0].get('publicKey');
    if (!broadcasterPublicKey) {
        throw new Error('No publicKey provided in URL');
    }
    const onReceivedFrameRef = useRef(onReceivedFrame);
    if (onReceivedFrameRef.current !== onReceivedFrame) {
        onReceivedFrameRef.current = onReceivedFrame;
    }
    useEffect(function setupViewer() {
        // If canvas is the same as last time and we already initialized, skip
        if (canvas === lastCanvasRef.current) {
            console.error('setupViewer canvas is the same as last time, skipping');
            return;
        }
        // Save the current canvas for comparison next time
        lastCanvasRef.current = canvas;
        // If no canvas, don't proceed with initialization
        if (!canvas) {
            console.log('setupViewer canvas was not defined, returning');
            setViewer(undefined); // Reset the controller when canvas is not available
            return;
        }
        console.log('setupViewerController canvas was defined', canvas);
        let mounted = true;
        const newViewer = new StreamrTvViewer(aesKey, broadcasterPublicKey);
        newViewer.on('viewerInfoChanged', (viewerInfo) => {
            setViewerCountCallback(streamId, viewerInfo.viewerCount);
        });
        newViewer.on('receivedFrame', () => {
            onReceivedFrameRef.current?.();
        });
        (async () => {
            try {
                await newViewer.start(streamId, canvas);
                if (!mounted) {
                    return;
                }
                console.log('setViewer', newViewer);
                setViewer(newViewer);
                onStartedRef.current?.(newViewer);
            }
            catch (e) {
                console.error(e);
            }
        })();
        return () => {
            mounted = false;
            newViewer.stop().catch(console.error.bind(console));
        };
    }, [
        streamId,
        canvas,
        setViewerCountCallback,
        aesKey,
        broadcasterPublicKey,
    ]);
    return viewer;
}
